import { useState, useEffect } from "react";
import { SoapCheckout, InsuredVehicle } from "@comparaonline/soap-schema";
import { Brand, Model } from "../types";

import { BFF_URL, HEADERS } from "../constants";

const ENDPOINT = `${BFF_URL}/autofact-homologation`;

type ExtendedSOAP = Partial<SoapCheckout> & {
  currentVehicle: InsuredVehicle;
  quoteFormId?: string;
};

type Vehicle = {
  brand: Brand;
  model: Model;
};

export const useVehicleHomologation = (
  SOAPForm?: ExtendedSOAP
): { vehicle: Vehicle; error?: string } => {
  const [vehicle, setVehicle] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    const fetchHomologatedVehicle = async () => {
      if (!SOAPForm) return;
      try {
        const { currentVehicle } = SOAPForm;
        const { brand, model } = currentVehicle.vehicle;

        const normalizedBrand = brand.toUpperCase();
        const normalizedModel = model.toUpperCase();
        const params = [
          `autofactBrand=${normalizedBrand}`,
          `autofactModel=${normalizedModel}`
        ].join("&");
        const endpointWithParams = [ENDPOINT, params].join("?");

        const response: Response = await fetch(endpointWithParams, { headers: HEADERS });
        const responseBody = await response.json();
        if (response.ok) {
          const {
            ciclBrandId,
            ciclBrandName,
            ciclModelId,
            ciclModelName
          } = responseBody.data.attributes;
          setVehicle({
            model: {
              id: `${ciclModelId}`,
              name: ciclModelName
            },
            brand: {
              id: `${ciclBrandId}`,
              name: ciclBrandName
            }
          });
        } else {
          setError(responseBody.statusCode);
        }
      } catch (error) {
        let message = error as string;
        if (error instanceof Error) {
          message = error.message;
        }
        setError(message);
      }
    };
    fetchHomologatedVehicle();
  }, [SOAPForm]);

  return { vehicle, error };
};
